import React,{useState, useEffect} from "react";
import {
  TextField,
  Button,
  makeStyles,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@material-ui/core";
import {
  Dashboard
} from "@material-ui/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { empIDMaxLength, numericRegex } from "config";
import { properCase } from "../utils";
import { useHistory } from "react-router-dom";
import { getWorkerActivity, getWorkerDetails,
   getPreviousPunches, updateWorkerLastPunchId } from '../services';
import {ROOT} from '../navigation/CONSTANTS';
import { ADMIN,SUPPORT } from "../config";
import clsx from "clsx";
import DrawerFooter from './DrawerFooter';
import Alert from "@material-ui/lab/Alert";

const inputProps = {
  maxLength: empIDMaxLength
};
const drawerWidth = 270;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  dialogContent: {
    paddingLeft: 35,
  },
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
   // alignItems: "center",
    minHeight: 120,
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
   // justifyContent: "center",
    alignItems: "center",
    width:'50%'
  },
  cardTitle: {
   // color: theme.palette.primary.main,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    fontWeight:'bold'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  paperStyle: {
    top: "unset",
    height: `calc(100% - 100px)`,
    border: "none",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: "auto",
  },
  list: {
    width: "100%",
    maxWidth: 360,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
}));

const ResetLastPunchId = () =>{

  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { isLoading, userRole, error:userRoleError } = useSelector(
    (state) => state.user.imtRole
  );
  const appConfig = useSelector((state) => state.appConfig);
  const { dscDrawerOpen } = appConfig;
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [empId, setEmpId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openConfirmationMessage, setOpenConfirmationMessage] = useState(false);
  const [confirmationMsgText, setConfirmationMsgText] = useState('');

  useEffect(() =>{
    if(userRole && Object.keys(userRole).length > 0){
      if(userRole.role !== ADMIN && userRole.role !== SUPPORT){
        history.push(ROOT);
      }
    }
    // else{
    //   console.log("userRoleError", userRoleError);
    //   if(userRoleError){
    //     history.push(ROOT);
    //   }
    // }

  },[userRole, userRoleError])

  const closeModalConfirmationMsg = () =>{
    setOpenConfirmationMessage(false);
    setConfirmationMsgText("");
  }

  const submitHandler = async (event) =>{
    event.preventDefault();
    setError("");
    setLoading(true);
    setDisableSubmit(true);
    try{
      getWorkerDetails(empId).then(workerDoc => {
      if(!workerDoc.exists){
        console.log("No Doc found for ", empId);
        setError("Worker is not found");
        setDisableSubmit(false);
        setLoading(false);
      }else{
        let workerDetails = {...workerDoc.data()};
        console.log("workerDetails", workerDetails);
        if(workerDetails && workerDetails.isActiveWorker && !workerDetails.isDeleted){
            getWorkerActivity(empId).then(workerActivityDoc =>{
              if(!workerActivityDoc){
                console.log("workerActivity Doc not found for ", empId);
                setError("WorkerActivity is not found");
                setDisableSubmit(false);
                setLoading(false);
              }else{
                let workerActivityDetails = {...workerActivityDoc.data()};
                console.log("workerActivityDetails ", workerActivityDetails);
                if(workerActivityDetails){
                  getPreviousPunches(empId).then(punchHistory =>{
                    console.log("punchHistory ", punchHistory);
                    if(punchHistory && punchHistory.length >0){
                      let lastPunchDetails = punchHistory[0];
                      console.log("last punch id ", lastPunchDetails);
                      if(workerActivityDetails.lastPunchId != undefined && lastPunchDetails && lastPunchDetails.id){
                        if(workerActivityDetails.lastPunchId !== lastPunchDetails.id){
                            updateWorkerLastPunchId( empId, lastPunchDetails.id).then(data =>{
                              if(data){
                                setConfirmationMsgText(`Last punch Id reset Successful for ${empId}`);
                                setOpenConfirmationMessage(true);
                                setError("");
                                setDisableSubmit(false);
                                setLoading(false);
                              }else{
                                console.log("error in updating last punch id");
                                setError("Lastpunch id not updated")
                                setDisableSubmit(false);
                                setLoading(false);
                              }
                            })
                          }else{
                            console.log("LastPunchId is already updated");
                            setError("last punch id is already updated");
                            setDisableSubmit(false);
                            setLoading(false);
                          }
                      }else{
                        console.log("LastPunchId not found");
                        setError("Last punch Id is not found");
                        setDisableSubmit(false);
                        setLoading(false);
                      }
                    }else{
                      console.log("No punches found for worker ", empId)
                      setError("punches not found for worker");
                      setDisableSubmit(false);
                      setLoading(false);
                    }
                  })
                } else{
                  console.log("workerActivity details is not found ", empId);
                  setError("workerActivity details not found for worker");
                  setDisableSubmit(false);
                  setLoading(false);
                }
              }
            })
        }else{
          console.log("worker is not active", empId);
          setError("Worker is not active");
          setDisableSubmit(false);
          setLoading(false);
        }
      }
    });
    
    }catch(err){
      console.log("error in resetting last punch Id", err);
      setLoading(false);
    }
  }

  const onEmployeeIdChange = (event) =>{
    event.preventDefault();
    setError("");
    if(numericRegex.test(event.target.value)){
    if (event.target.value === "") {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
    setEmpId(event.target.value);
    }
  }

  return(
    <div className={classes.root}>
    <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: dscDrawerOpen,
            [classes.drawerClose]: !dscDrawerOpen,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: dscDrawerOpen,
              [classes.drawerClose]: !dscDrawerOpen,
            }),
          }}
          PaperProps={{ className: classes.paperStyle }}
        >
          <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.list}
      >
        <ListItem
          button
        // selected={selectedIndex === 0}
          onClick={() => history.push(ROOT)}
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText
          style={{color:"black"}}
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("pgReview.tlDashboard"))}
          />
        </ListItem>
        <Divider />
        </List>
        <DrawerFooter />
      </Drawer>
      <main className={classes.content}>
    {isLoading ? <>
        <CircularProgress />
    </> : userRoleError || !userRole || !userRole.role || (userRole.role !== ADMIN  && userRole.role !== SUPPORT) ? 
          <>
          <Alert severity="info">{userRoleError}. Restrcited Access.</Alert>
          </>
    :
        <form noValidate autoComplete="off" onSubmit={submitHandler}>
          <Box className={classes.outerContainer}>
          <Box style={{width:'50%'}}>
              <Typography
                noWrap
                variant="subtitle1"
                component="h2"
                className={classes.cardTitle}
              >
                Reset Last Punch Id
              </Typography>
              </Box>
            <Box className={classes.innerContainer}>
              <Box>
                <TextField
                  label={t("pgHome.phEmpId")}
                  autoFocus
                  required
                  variant="outlined"
                  value={empId}
                  placeholder={t("pgHome.phEmpId")}
                  onChange={onEmployeeIdChange}
                  error={error ? true : false}
                  helperText={
                    error
                      ? t(error)
                      : loading
                      ? properCase(t("pgHome.loadingWorker"))
                      : ""
                  }
                  inputProps={inputProps}
                  size="small"
                />
              </Box>

              <Box pl={4}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={disableSubmit}
                //  isLoading={loading}
                >
                  {properCase(t("pgHome.btEmpId"))}
                </Button>
              </Box>
            </Box>
          </Box>
        </form>
        }
        <Dialog
        open={openConfirmationMessage}
        onClose={closeModalConfirmationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {"Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{confirmationMsgText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalConfirmationMsg} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>
      </main>
    </div>
  )
}

export default ResetLastPunchId;